import type { AddressInformation, WahlGeoInformation } from "@/lib/api/GeoCoordinates";

export interface V1DetermineWkRequest {
	address: string;
}

export interface V1DetermineWkResponse {
	address?: AddressInformation,
	info: WahlGeoInformation[]
}

export interface V1DetermineWksMessageTypeRequest {
	address: string;
}

export function isV1DetermineWksMessageTypeRequest(obj: any)
	: obj is V1DetermineWksMessageTypeRequest {
	return obj.address !== undefined && typeof obj.address === "string";
}

export interface V1DetermineWksMessageTypeResponse {
	address?: AddressInformation;
	info: WahlGeoInformation[];
}

export function isV1DetermineWksMessageTypeResponse(obj: any)
	: obj is V1DetermineWksMessageTypeResponse {
	return obj.info !== undefined && Array.isArray(obj.info);
}

export type V1DetermineWksMessage = V1DetermineWksMessageTypeRequest
	| V1DetermineWksMessageTypeResponse;